module.exports = __webpack_public_path__ + "static/media/help_sneakymercury.b2dd8e612.PNG";